module.exports = __webpack_public_path__ + "static/img/3595_phase_function_Paper_PointsHejduk_Prediction.c0e0c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3595_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MccC
// module chunks = 0